import { render, staticRenderFns } from "./tree-new.vue?vue&type=template&id=4e19f896&scoped=true"
import script from "./tree-new.vue?vue&type=script&lang=ts"
export * from "./tree-new.vue?vue&type=script&lang=ts"
import style0 from "./tree-new.vue?vue&type=style&index=0&id=4e19f896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e19f896",
  null
  
)

export default component.exports